import { useNavigate } from 'react-router-dom';
import toast from '../utils/toast';
import { confidentialAPI } from '../services/api';

/**
 * Custom hook for handling offboarding workflow withdrawals
 * Consolidates duplicate withdrawal logic across all offboarding steps
 */
const useWithdrawal = () => {
  const navigate = useNavigate();

  const handleWithdrawal = async (withdrawalData, onSuccess) => {
    try {
      console.log('Processing withdrawal:', withdrawalData);

      // Expect workflowId to be present in withdrawalData or derive elsewhere if needed
      const workflowId = withdrawalData?.workflowId || withdrawalData?.id || withdrawalData?.workflow_id;

      // Fall back to simulation if we don't have an id
      if (!workflowId) {
        console.warn('No workflowId provided for withdrawal. Falling back to simulated success.');
        await new Promise(resolve => setTimeout(resolve, 500));
      } else {
        // Call backend to mark workflow as withdrawn
        await confidentialAPI.withdrawOffboardingWorkflow(workflowId, {
          reason: withdrawalData.reason,
          additional_notes: withdrawalData.additionalNotes,
          step: withdrawalData.step,
        });
      }

      toast.success('Withdrawal request submitted successfully');

      // Call success callback if provided (to refresh data)
      if (onSuccess) {
        onSuccess();
      }

      // Navigate back to employee lifecycle page with refresh + optimistic update flag
      navigate('/admin/employee-lifecycle', { state: { refreshWorkflows: true, optimisticWithdrawalId: workflowId || null } });

    } catch (error) {
      console.error('Withdrawal failed:', error);
      toast.error('Failed to process withdrawal request');
      throw error;
    }
  };

  return { handleWithdrawal };
};

export default useWithdrawal;
